import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Drawer, Button, Space, Modal } from "antd";
import { faFilter, faEye, faTrash, faInfoCircle, faCheckCircle, faCloudDownload, faCogs, faSearch } from '@fortawesome/free-solid-svg-icons';
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
// import VendorListDeletePopUp from "./DeletePopUp";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import * as XLSX from "xlsx";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  getResultData,
} from "../../../controllers/V1/hourlyGamesController";
import { getPage, getRelativeTime } from "../../../controllers/common";
import { getCrunchSettings } from "../../../controllers/V1/hourlyAnalyserController";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { usePermissions } from "../../../controllers/PermissionContext";
import "./hourlyAnalyserResponsive.css";

// Hourly slots always use UAE time (Asia/Dubai, UTC+4, no DST).
const UAE_UTC_OFFSET_MINUTES = 240;
const nowInUae = () => moment.utc().utcOffset(UAE_UTC_OFFSET_MINUTES);
const parseInUae = (input, format) => {
  const parsed = format ? moment(input, format) : moment(input);
  return parsed.utcOffset(UAE_UTC_OFFSET_MINUTES, true);
};

// Static hourly draw slots: 5 PM through 12 AM UAE (17:00–23:00 same day, 00:00 next day).
const STATIC_SLOT_HOURS = [17, 18, 19, 20, 21, 22, 23, 0];
const buildStaticHourSlots = (selectedDate) =>
  STATIC_SLOT_HOURS.map((hour) => {
    const isNextDay = hour === 0;
    const slotDate = isNextDay
      ? parseInUae(selectedDate, "YYYY-MM-DD").add(1, "day").format("YYYY-MM-DD")
      : selectedDate;
    return {
      slot_time: `${String(hour).padStart(2, "0")}:00:00`,
      slot_date: slotDate,
      is_next_day_slot: isNextDay ? "Y" : "N",
    };
  });

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const hourlyAnalyserPermission = usePermissions("hourlyAnalyser");
  const canManageHourlySettings =
    hourlyAnalyserPermission?.fullAccess === "Y" || hourlyAnalyserPermission?.settings === "Y";
  const canSearchHourlyResult =
    hourlyAnalyserPermission?.fullAccess === "Y" || hourlyAnalyserPermission?.search === "Y";
  const hourlyActionColumns = (canManageHourlySettings ? 1 : 0) + (canSearchHourlyResult ? 1 : 0);
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () =>  setFilterShow(!isFilterShow); 
  const [isHourPopupShow, setIsHourPopupShow] = useState(false);
  const [selectedHourlyGame, setSelectedHourlyGame] = useState(null);
  const [selectedHourDate, setSelectedHourDate] = useState(nowInUae().format("YYYY-MM-DD"));
  const [hourSlots, setHourSlots] = useState([]);
  const maxHourDate = nowInUae().format("YYYY-MM-DD");
  const minHourDate = nowInUae().subtract(4, "days").format("YYYY-MM-DD");
  const [isResultPopupShow, setIsResultPopupShow] = useState(false);
  const [resultRows, setResultRows] = useState([]);
  const [resultSearchText, setResultSearchText] = useState("");
  const [resultLoading, setResultLoading] = useState(false);
  const [resultTransactionId, setResultTransactionId] = useState("");
  const [resultPage, setResultPage] = useState(1);
  const [resultPageSize, setResultPageSize] = useState(25);
  const [isCouponPopupShow, setIsCouponPopupShow] = useState(false);
  const [isForceRunPopupShow, setIsForceRunPopupShow] = useState(false);
  const [forceRunLoading, setForceRunLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [forceRunStatusResult, setForceRunStatusResult] = useState("");
  const [forceRunForm, setForceRunForm] = useState({
    productname: "",
    start: "",
    end: "",
    transactionid: "",
  });
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [couponRows, setCouponRows] = useState([]);
  const [couponColumns, setCouponColumns] = useState([]);
  const [selectedCouponCode, setSelectedCouponCode] = useState("");
  const [couponDetailsCache, setCouponDetailsCache] = useState({});
  const isMobileView = viewportWidth <= 767;
  const isTabletView = viewportWidth <= 1024;
  const getHourSlotLabel = (slot) => {
    const slotTime = slot?.slot_time || slot?.draw_time_string?.split(" ")?.[1] || "00:00";
    const hourStart = slotTime.slice(0, 5);
    return `${hourStart} - ${hourStart.slice(0, 2)}:59`;
  };
  const getSlotHour = (slot) => {
    const slotTime = slot?.slot_time || slot?.draw_time_string?.split(" ")?.[1] || "00:00";
    return parseInt(slotTime.split(":")[0], 10);
  };

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [helpText, setHelpText] = useState('');
  const handleSearchByChange = (e) => {
    try {
      const {value} = e.target;
      if(value === 'invoice_date'){
        setHelpText('Format should be YYYY-MM-DD. (e:g 2024-12-25)');
      } else if(value === 'payment_mode'){
        setHelpText('Enter Cash/Online only.');
      } else{
        setHelpText('');
      }
    } catch (error) {
      
    }
  }

  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: "",
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const handleHourPopup = (item = null) => {
    setSelectedHourlyGame(item);
    setSelectedHourDate(nowInUae().format("YYYY-MM-DD"));
    setHourSlots([]);
    setIsHourPopupShow((prev) => !prev);
  };

  
  const handleCouponPopupClose = () => {
    setIsCouponPopupShow(false);
  };
  const formatDateTimeForInput = (value) => {
    if (!value) return "";
    const parsed = moment(value, ["DD-MM-YYYY HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm"], true);
    if (parsed.isValid()) return parsed.format("YYYY-MM-DDTHH:mm:ss");
    return "";
  };
  const formatDateTimeForApi = (value) => {
    const parsed = moment(value);
    return parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm:ss") : "";
  };
  const getDrawHourEnd = (startValue) => {
    const startMoment = moment(startValue);
    if (!startMoment.isValid()) return "";
    return startMoment.clone().startOf("hour").minute(59).second(59).format("YYYY-MM-DDTHH:mm:ss");
  };
  const buildTransactionId = ({ productname = "", start = "" }) => {
    const startMoment = moment(start);
    if (!productname?.trim() || !startMoment.isValid()) return "";
    const hourStart = startMoment.clone().startOf("hour");
    const hourEnd = startMoment.clone().startOf("hour").minute(59).second(59);
    const compactProduct = productname.replace(/\s+/g, "").replace(/\//g, "_");
    return `${compactProduct}-${hourStart.format("DDMMYYYYHHmmss")}-${hourEnd.format("DDMMYYYYHHmmss")}`;
  };
  const handleOpenForceRunPopup = () => {
    const selectedDate = selectedHourDate || nowInUae().format("YYYY-MM-DD");
    const currentHour = nowInUae().hour();
    const startValue = parseInUae(
      `${selectedDate} ${String(currentHour).padStart(2, "0")}:00:00`,
      "YYYY-MM-DD HH:mm:ss"
    ).format("YYYY-MM-DDTHH:mm:ss");
    const endValue = parseInUae(
      `${selectedDate} ${String(currentHour).padStart(2, "0")}:59:59`,
      "YYYY-MM-DD HH:mm:ss"
    ).format("YYYY-MM-DDTHH:mm:ss");
    const productname = selectedHourlyGame?.title || "";
    setForceRunForm({
      productname,
      start: startValue,
      end: endValue,
      transactionid: buildTransactionId({
        productname,
        start: startValue,
      }),
    });
    setForceRunStatusResult("");
    setIsForceRunPopupShow(true);
  };
  const handleForceRunInputChange = (field, value) => {
    setForceRunForm((prev) => {
      const updatedForm = {
        ...prev,
        [field]: value,
      };
      if (field === "start") {
        updatedForm.end = getDrawHourEnd(value);
      }
      if (field !== "transactionid") {
        updatedForm.transactionid = buildTransactionId(updatedForm);
      }
      return updatedForm;
    });
  };
  const handleForceRunAnalyser = async () => {
    try {
      if (!forceRunForm?.productname?.trim() || !forceRunForm?.start || !forceRunForm?.end) {
        notification.warning({
          message: "Missing fields",
          description: "Please enter product name, start and end date-time.",
        });
        return;
      }
      const drawEnd = formatDateTimeForApi(getDrawHourEnd(forceRunForm.start));
      const payload = {
        method: "forcedhourly",
        productname: forceRunForm.productname?.replace(/\//g, '_')?.trim(),
        start: formatDateTimeForApi(forceRunForm.start),
        end: drawEnd,
      };
      if (!payload.start || !payload.end) {
        notification.warning({
          message: "Invalid date-time",
          description: "Please select valid start and end date-time.",
        });
        return;
      }
      setForceRunLoading(true);
      const response = await getCrunchSettings(payload);
      if (response?.status === true) {
        notification.success({
          message: "Force run request submitted",
          description: response?.result?.statusMessage || "Hourly analyser triggered successfully.",
        });
        setIsForceRunPopupShow(false);
      } else {
        notification.error({
          message: "Unable to force run analyser",
          description: response?.message || "Please try again.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Unable to force run analyser",
        description: error?.message || "Please try again.",
      });
    } finally {
      setForceRunLoading(false);
    }
  };
  const handleCheckForceRunStatus = async () => {
    try {
      if (!forceRunForm?.productname?.trim() || !forceRunForm?.transactionid?.trim()) {
        notification.warning({
          message: "Missing fields",
          description: "Please enter product name and transaction ID.",
        });
        return;
      }
      setStatusLoading(true);
      const statusPayload = {
        method: "checktransaction",
        transactionid: forceRunForm.transactionid?.replace(/\//g, '_')?.trim(),
        productname: forceRunForm.productname?.replace(/\//g, '_')?.trim(),
      };
      const response = await getCrunchSettings(statusPayload);
      if (response?.status === true) {
        const transactionStatus = response?.result?.transactionstatus || response?.result?.statusMessage || "Status received";
        setForceRunStatusResult(String(transactionStatus));
        notification.success({
          message: "Status fetched",
          description: `Transaction status: ${transactionStatus}`,
        });
      } else {
        setForceRunStatusResult("");
        notification.error({
          message: "Unable to fetch status",
          description: response?.message || "Please try again.",
        });
      }
    } catch (error) {
      setForceRunStatusResult("");
      notification.error({
        message: "Unable to fetch status",
        description: error?.message || "Please try again.",
      });
    } finally {
      setStatusLoading(false);
    }
  };

  const handleEdit = async (item = {}) => {
    navigate("/invoice/addeditdata", { state: item });
  };

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);

      const options = {
        type: "",
        condition: {
          ...(filter.filter_by === 'users_name'?{ users_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter.filter_by === 'store'?{store : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter.filter_by === 'users_mobile'?{ users_mobile : parseInt(filter?.search) }:null),
          ...(filter.filter_by === 'pos_number'?{ pos_number : parseInt(filter?.search) }:null),
          ...(filter.filter_by === 'invoice_no'?{ invoice_no : parseInt(filter?.search) }:null),
          ...(filter.filter_by === 'sales_person_name'?{ sales_person_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter.filter_by === 'payment_mode'?{ payment_mode : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter.filter_by === 'batch_no'?{ batch_no : parseInt(filter?.search) }:null),
          ...(filter.filter_by === 'status'?{status : { $regex: filter?.search, $options: "i" }}:null),
          ...(filter.filter_by === 'sub_total_due'?{sub_total_due : parseFloat(filter?.search) }:null),
          ...(showRequest ? { status: showRequest } : null),
          
          ...(filter.filter_by === 'invoice_date'?{ invoice_date : {$gte : new Date(`${filter?.search} 0:01:00`), $lte : new Date(`${filter?.search} 23:59:00`)} }:null),

          ...(filter?.from?{start_date : {$gte : new Date(`${filter.from} 0:01:00`), $lte : new Date(`${filter.from} 23:59:00`)} }:null),
          ...(filter?.to?{end_date : {$gte : new Date(`${filter.to} 0:01:00`), $lte : new Date(`${filter.to} 23:59:00`)} }:null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };
 
  
  const dropdownMenu = (items) => {
    return (
      <>
        <Menu>
          {/* <Menu.Item key="01"onClick={()=>handlePDFDownload(items)}>
            <FontAwesomeIcon icon={faEye} />
            <span className="show_span_edit">PDF</span>
          </Menu.Item> */}
          {/* <Menu.Item key={`02`} onClick={() => { handleRemove(items._id); }} >
           <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Remove</span>
          </Menu.Item> */}
        </Menu>
      </>
    );
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Request List";
  }, [currentPage, showRequest, filter]);

  const handleSetting = (item) => {
    navigate("/hourly-analyser/settings", { state: item });
  }

  useEffect(() => {
    if (!isHourPopupShow || !selectedHourDate) return;
    setHourSlots(buildStaticHourSlots(selectedHourDate));
  }, [isHourPopupShow, selectedHourDate]);

  const isFutureHourSlot = (slot) => {
    const slotMoment = parseInUae(
      `${slot?.slot_date} ${slot?.slot_time}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    return slotMoment.isAfter(nowInUae());
  };

  const handleHourSlotClick = (item, slot, selectedDate) => {
    if (!isFutureHourSlot(slot)) {
      handleShowResult(item, slot, selectedDate);
      return;
    }

    const slotLabel = parseInUae(
      `${slot?.slot_date} ${slot?.slot_time}`,
      "YYYY-MM-DD HH:mm:ss"
    ).format("hh:mm A, DD/MM/YYYY");

    Modal.confirm({
      title: "Future hour selected",
      content: `You selected a future time (${slotLabel}). Do you want to continue?`,
      okText: "Yes, Continue",
      cancelText: "Cancel",
      onOk: () => handleShowResult(item, slot, selectedDate),
    });
  };

  const handleShowResult = async (item, slot, selectedDate) => {
    try {
      setResultLoading(true);
      const game = item?.title
                    ?.replace(/ /g, '')
                    ?.replace(/\//g, '_');
      let slotDate = "";
      if(selectedHourDate !== slot?.slot_date){
        if(slot?.is_next_day_slot === "Y"){
          slotDate = moment(selectedHourDate).add(1, 'day').format("YYYY-MM-DD");
        } else{
          slotDate = moment(selectedHourDate).format("YYYY-MM-DD");
        }
      } else{
        slotDate = moment(slot?.slot_date).format("YYYY-MM-DD");
      }
      // const slotDate = selectedDate || slot?.slot_date || nowInUae().format("YYYY-MM-DD");
      const hour = getSlotHour(slot);
      const formattedDate = parseInUae(slotDate, "YYYY-MM-DD").format("DDMMYYYY");
      const hourStr = String(hour).padStart(2, "0");
      const dateTime = `${formattedDate}${hourStr}0000-${formattedDate}${hourStr}5959`;
      const transactionid = `${game?.replace(/\//g, '_')}-${dateTime}`;
      const options = {
        method : "checktransaction",
        transactionid,
        productname : item?.title?.replace(/\//g, '_'),
      }
      const res = await getCrunchSettings(options);
      if(res.status === true && res?.result?.transactionstatus === "Complete"){
        const resultRes = await getResultData({ transactionid });
        if(resultRes?.status !== true){
          throw new Error(resultRes?.message || "Unable to fetch output data.");
        }
        const parsedRows = Array.isArray(resultRes?.result) ? resultRes.result : [];
        setIsHourPopupShow(false);
        navigate("/hourly-analyser/result-coupons", {
          state: {
            resultRows: parsedRows,
            transactionId: transactionid,
            selectedHourlyGame: item,
            hourSlot: hour,
            slotDate,
          },
        });
      } else if(res.status === true) {
        notification.warning({
          message: "Result not ready",
          description: "Transaction status is not complete yet.",
        });
      } else {
        notification.error({
          message: "Unable to check result",
          description: res?.message || "Please try again.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Unable to load result data",
        description: error?.message || "Please try again.",
      });
    } finally {
      setResultLoading(false);
    }
  }
  const handleCouponClick = async (couponCode = "") => {
    try {
      const normalizedCoupon = String(couponCode || "").replaceAll(",", "-").trim();
      if (!resultTransactionId || !normalizedCoupon) {
        notification.warning({
          message: "Coupon details unavailable",
          description: "Please load result data first and try again.",
        });
        return;
      }
      const cacheKey = `${resultTransactionId}__${normalizedCoupon}`;
      if (couponDetailsCache?.[cacheKey]) {
        const cachedRows = couponDetailsCache[cacheKey];
        setCouponRows(cachedRows);
        setCouponColumns(Object.keys(cachedRows[0] || {}));
        setSelectedCouponCode(String(couponCode || ""));
        setIsCouponPopupShow(true);
        return;
      }
      setResultLoading(true);
      const detailsUrl = `https://testanalyzer002.gamedubai.primeapps.co.in/usrdata/cdata/${resultTransactionId}/details/${normalizedCoupon}/data.json`;
      const detailsResponse = await fetch(detailsUrl);
      if (!detailsResponse.ok) {
        throw new Error("Unable to fetch coupon details.");
      }
      const rawDetailsData = await detailsResponse.json();
      const parsedDetailsRows = Array.isArray(rawDetailsData)
        ? rawDetailsData
        : Array.isArray(rawDetailsData?.data)
          ? rawDetailsData.data
          : Array.isArray(rawDetailsData?.result)
            ? rawDetailsData.result
            : rawDetailsData && typeof rawDetailsData === "object"
              ? [rawDetailsData]
              : [];
      if (!parsedDetailsRows.length) {
        notification.warning({
          message: "No details found",
          description: `No records available for coupon ${couponCode}.`,
        });
        return;
      }
      setCouponDetailsCache((prev) => ({
        ...prev,
        [cacheKey]: parsedDetailsRows,
      }));
      setCouponRows(parsedDetailsRows);
      setCouponColumns(Object.keys(parsedDetailsRows[0] || {}));
      setSelectedCouponCode(String(couponCode || ""));
      setIsCouponPopupShow(true);
    } catch (error) {
      notification.error({
        message: "Unable to load coupon details",
        description: error?.message || "Please try again.",
      });
    } finally {
      setResultLoading(false);
    }
  };

  const filteredResultRows = resultRows.filter((row) => {
    if (!resultSearchText) return true;
    return Object.values(row || {}).some((value) =>
      String(value ?? "").toLowerCase().includes(resultSearchText.toLowerCase())
    );
  });
  const resultColumns = filteredResultRows.length > 0
    ? Object.keys(filteredResultRows[0] || {})
    : resultRows.length > 0
      ? Object.keys(resultRows[0] || {})
      : [];
  const toNumber = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
  };
  const getRowAmount = (row = {}) => {
    const existingAmount = row?.amount ?? row?.total_amount ?? row?.price_amount;
    if (existingAmount !== undefined && existingAmount !== null && existingAmount !== "") {
      return toNumber(existingAmount);
    }
    const qty = row?.qty ?? row?.quantity ?? row?.units ?? row?.count;
    const price = row?.price ?? row?.rate ?? row?.unit_price;
    if (qty !== undefined && price !== undefined) {
      return toNumber(qty) * toNumber(price);
    }
    return 0;
  };
  const resultTotalPages = Math.max(1, Math.ceil(filteredResultRows.length / resultPageSize));
  const safeResultPage = Math.min(resultPage, resultTotalPages);
  const paginatedResultRows = filteredResultRows.slice(
    (safeResultPage - 1) * resultPageSize,
    safeResultPage * resultPageSize
  );
  const pageAmountTotal = paginatedResultRows.reduce((sum, row) => sum + getRowAmount(row), 0);
  const overallAmountTotal = filteredResultRows.reduce((sum, row) => sum + getRowAmount(row), 0);
  const handleExportResultExcel = () => {
    try {
      if (!filteredResultRows.length) {
        notification.warning({
          message: "No data to export",
          description: "Please load result data before exporting.",
        });
        return;
      }

      const activeMatchNumbers = Array.from(
        { length: selectedHourlyGame?.game_type || 0 },
        (_, index) => index + 1
      ).filter((matchNumber) => selectedHourlyGame?.[`rumble_prize_${matchNumber}`] > 0);

      const exportRows = filteredResultRows.map((row) => {
        const formattedRow = {
          Coupon: row?.ser ?? "",
        };

        activeMatchNumbers.forEach((matchNumber) => {
          formattedRow[`Match ${matchNumber}`] = row?.[`r${matchNumber}c`] ?? "";
          formattedRow[`Match ${matchNumber} Amt.`] = row?.[`r${matchNumber}a`] ?? "";
        });

        formattedRow["Total Match Count"] = row?.tmc ?? "";
        formattedRow["Total Match Amt."] = row?.ta ?? "";

        return formattedRow;
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportRows);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Hourly Result");
      XLSX.writeFile(
        workbook,
        `Hourly-Analysis-Result-${moment().format("YYYY-MM-DD-HH-mm-ss")}.xlsx`
      );
    } catch (error) {
      notification.error({
        message: "Export failed",
        description: error?.message || "Unable to export excel file.",
      });
    }
  };

  useEffect(() => {
    setResultPage(1);
  }, [resultSearchText, resultRows, resultPageSize]);

  const getHeaderColumns = (column) => {
    try {
      switch(column){
        case "ser":
          return "Series";
        case "tmc":
          return "Total Match";
        case "ta":
          return "Total Amount";
        case "s1c":
          return "Straight 1 Count";
        case "s1c":
          return "Straight 1 Count";
        
      }
    } catch (error) {
      return [];
    }
  }


  return (
    <>
      <LoadingEffect isLoading={resultLoading} text="Loading result data..." />
      <div className="container-fluid hourly-page-container" ref={targetRef}>
        <TobNavBar title={"Hourly Games"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                  <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filters
                    </Link>
                  </div>

                  <div className="inventory_filter_div" onClick={handleExportDrawer}>
                  <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Export
                    </Link>
                  </div>

                  <div onClick={() => handleEdit()}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Add New</span>
                    </button>
                  </div>
                </div>
              </div>
            </Box>             */}
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive hourly-table-scroll">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              {/* <th>Image</th> */}
                              <th>Title</th>
                              <th>Price.</th>
                              
                              <th>Status</th>
                              <th colSpan={hourlyActionColumns || 1}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    {/* <td>{items?.game_image}</td> */}
                                    <td>{items?.title}</td>
                                    <td>{items?.price}</td>
                                    <td className="admin_user_list_date">{items?.status}</td>
                                    {canManageHourlySettings ? (
                                      <td>
                                        <button type="button" class="btn btn-dark" onClick={() => handleSetting(items)}>
                                          <span className="request_new_categories">
                                            <FontAwesomeIcon icon={faCogs} />
                                          </span>
                                        </button>
                                      </td>
                                    ) : null}
                                    {canSearchHourlyResult ? (
                                      <td>
                                        <button type="button" class="btn btn-dark" onClick={() => handleHourPopup(items)}>
                                          <span className="request_new_categories">
                                            <FontAwesomeIcon icon={faSearch} />
                                          </span>
                                        </button>
                                      </td>
                                    ) : null}
                                    {!canManageHourlySettings && !canSearchHourlyResult ? (
                                      <td>-</td>
                                    ) : null}
                                    {/* <td>
                                      <Dropdown
                                        overlay={() => dropdownMenu(items)}
                                        placement="bottomLeft"
                                        arrow
                                      >
                                          <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td> */}
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={9} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Filter */}
      <Drawer
        title={`Hourly Slots${selectedHourlyGame?.title ? ` - ${selectedHourlyGame.title}` : ""}`}
        placement={`right`}
        width={isMobileView ? "100%" : isTabletView ? "85%" : 600}
        onClose={() => handleHourPopup(null)}
        open={isHourPopupShow}
      >
        <div className="container-fluid px-0 hourly-drawer-content">
          <div className="d-flex justify-content-end mb-3">
            <Button type="primary" onClick={handleOpenForceRunPopup}>
              Force Run Analyzer
            </Button>
          </div>
          <div className="form-group mb-3">
            <label htmlFor="hourlyDate" className="all_section_for_label_main_class">
              Date (UAE) : 
            </label>
            <input
              type="date"
              id="hourlyDate"
              className="form-control store_input_field"
              value={selectedHourDate}
              min={minHourDate}
              max={maxHourDate}
              onChange={(e) => setSelectedHourDate(e.target.value)}
            />   
          </div>
          <div className="row hourly-slot-grid">
            {hourSlots.map((slot, index) => {
              const nowUae = nowInUae();
              const isCurrentHourSlot = parseInUae(
                `${slot.slot_date} ${slot.slot_time}`,
                "YYYY-MM-DD HH:mm:ss"
              ).isSame(nowUae, "hour");

              return (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
                key={`${selectedHourDate}-${slot?.slot_time || index}`}
                onClick={() => handleHourSlotClick(selectedHourlyGame, slot, selectedHourDate)}
              >
                <div
                  className={`card shadow-sm hourly-slot-card${isCurrentHourSlot ? " hourly-slot-current" : ""}`}
                >
                  <div className="card-body text-center">
                    <h6 className="mb-0">
                      {parseInUae(`${selectedHourDate} ${slot.slot_time}`, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}
                    </h6>
                    <small className="text-muted">
                      {parseInUae(slot.slot_date, "YYYY-MM-DD").format("DD/MM/YYYY")}
                    </small>
                  </div>
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </Drawer>
      <Modal
        title="Force Run Hourly Analyzer"
        open={isForceRunPopupShow}
        onCancel={() => {
          setIsForceRunPopupShow(false);
          setForceRunStatusResult("");
        }}
        onOk={handleForceRunAnalyser}
        okText="Run"
        confirmLoading={forceRunLoading}
        footer={[
          <Button key="cancel" onClick={() => {
            setIsForceRunPopupShow(false);
            setForceRunStatusResult("");
          }}>
            Cancel
          </Button>,
          <Button key="status" onClick={handleCheckForceRunStatus} loading={statusLoading}>
            Get Status
          </Button>,
          <Button key="run" type="primary" onClick={handleForceRunAnalyser} loading={forceRunLoading}>
            Run
          </Button>,
        ]}
      >
        <div className="form-group mb-3">
          <label htmlFor="forceProductName" className="all_section_for_label_main_class">
            Product Name
          </label>
          <input
            id="forceProductName"
            type="text"
            className="form-control store_input_field"
            value={forceRunForm.productname}
            onChange={(e) => handleForceRunInputChange("productname", e.target.value)}
            placeholder="Enter product name"
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="forceStartDate" className="all_section_for_label_main_class">
            Draw Date
          </label>
          <input
            id="forceStartDate"
            type="datetime-local"
            className="form-control store_input_field"
            value={formatDateTimeForInput(forceRunForm.start) || forceRunForm.start}
            onChange={(e) => handleForceRunInputChange("start", e.target.value)}
          />
        </div>
        <div className="form-group mb-0">
          <label htmlFor="forceTransactionId" className="all_section_for_label_main_class">
            Transaction ID
          </label>
          <input
            id="forceTransactionId"
            type="text"
            className="form-control store_input_field"
            value={forceRunForm.transactionid}
            onChange={(e) => handleForceRunInputChange("transactionid", e.target.value)}
            placeholder="e.g. HOURLY4-06052026140000-06052026145959"
          />
        </div>
        {/* <div className="form-group mb-0 mt-3">
          <label htmlFor="forceEndDate" className="all_section_for_label_main_class">
            End
          </label>
          <input
            id="forceEndDate"
            type="datetime-local"
            className="form-control store_input_field"
            value={formatDateTimeForInput(forceRunForm.end) || forceRunForm.end}
            onChange={(e) => handleForceRunInputChange("end", e.target.value)}
          />
        </div> */}
        {forceRunStatusResult ? (
          <div className="alert alert-info mt-3 mb-0" role="alert">
            Current Status: {forceRunStatusResult}
          </div>
        ) : null}
      </Modal>
      
    </>
  );
}
